import React from 'react';
import WhatsAppTab from './Whatsapp/WhatsAppTab';
import InstagramTab from './InstagramTab';
import FacebookTab from './FacebookTab';


function ProjectWiseTab({ socialMedia, project, categoryTab, onTabClick }) {
  switch (socialMedia) {
    case 'whatsapp':
      return <WhatsAppTab project={project} categoryTab={categoryTab} onTabClick={onTabClick}/>;
    case 'instagram':
      return <InstagramTab project={project} categoryTab={categoryTab} />;
    case 'facebook':
      return <FacebookTab project={project} categoryTab={categoryTab} />;
   
    default:
      return (
        <div className="flex flex-col items-center justify-center h-full py-16">
          <div className="flex items-center mb-4">
            <svg className="w-10 h-10 text-flamingo-500 animate-bounce mr-2" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" fill="none" />
              <path d="M8 12h8M12 8v8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
            <span className="text-2xl font-semibold text-flamingo-600">Coming Soon</span>
          </div>
          <p className="text-gray-600 text-center max-w-md">
            We're working hard to bring this social media platform to you soon.<br />
            Stay tuned for updates!
          </p>
        </div>
      );
  }
}
export default ProjectWiseTab;